import { colors } from '@core/assistant/colors';

const TOP_PX_PER_OPTION = 20;
const RESULT_BOX_HEIGHT = 52; // reserved for "correct answer" result message

export const useStyles = (maxOptions = 0) => {
  const top = `-${maxOptions * TOP_PX_PER_OPTION + RESULT_BOX_HEIGHT}px`;

  return {
    container: {
      position: 'absolute',
      left: '-330px',
      top,
      width: 300,
      background: '#3A3A3A',
      borderRadius: 4,
      padding: '16px',
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      zIndex: 1200,
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    headerText: {
      color: colors.white,
      fontSize: 14,
    },
    progressBar: {
      borderRadius: 99,
      backgroundColor: '#5A5A5A',

      '& .MuiLinearProgress-bar': {
        backgroundColor: colors.myta,
        borderRadius: 99,
      },
    },
    questionCard: {
      background: '#4A4A4A',
      borderRadius: 3,
      padding: '14px 16px',
    },
    questionLabel: {
      color: colors.grey_200,
      fontSize: 11,
      letterSpacing: 1,
      mb: 1,
    },
    questionText: {
      color: colors.white,
      fontSize: 15,
      fontWeight: 700,
    },
    optionsList: {
      display: 'flex',
      flexDirection: 'column',
      gap: 1,
    },
    optionRow: (isMulti: boolean) => ({
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
      borderRadius: isMulti ? 2 : 99,
      padding: '10px 14px',
    }),
    optionBadge: (isMulti: boolean) => ({
      width: 30,
      height: 30,
      borderRadius: isMulti ? 1 : '50%',
      background: 'rgba(0,0,0,0.2)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    }),
    optionBadgeText: {
      color: colors.white,
      fontSize: 13,
      fontWeight: 700,
    },
    optionText: {
      color: colors.white,
      fontSize: 14,
      flex: 1,
    },
    optionIcon: {
      color: colors.white,
      fontSize: 16,
      fontWeight: 700,
    },
    resultBox: {
      border: '1px solid #E53935',
      borderRadius: 2,
      padding: '10px 14px',
      background: 'rgba(229, 57, 53, 0.15)',
    },
    resultText: {
      color: '#E57373',
      fontSize: 13,
    },
    confirmButton: {
      background: colors.myta,
      borderRadius: 99,
      color: colors.white,
      fontWeight: 700,
      fontSize: 14,
      textTransform: 'none',
      padding: '12px',

      '&:hover': {
        background: colors.blue_second,
      },
      '&.Mui-disabled': {
        background: '#3A3A5A',
        color: '#8888AA',
      },
    },
    nextButton: {
      background: colors.myta,
      borderRadius: 99,
      color: colors.white,
      fontWeight: 700,
      fontSize: 14,
      textTransform: 'none',
      padding: '12px',

      '&:hover': {
        background: colors.blue_second,
      },
    },
  };
};

export const getOptionStyle = (
  i: number,
  confirmed: boolean,
  isSelected: boolean,
  correctAnswers: number[],
  hasCorrectAnswers: boolean,
) => {
  if (!confirmed) {
    return {
      border: `1px solid ${isSelected ? colors.myta : '#6A6A6A'}`,
      background: isSelected ? 'rgba(69, 84, 229, 0.6)' : 'transparent',
      cursor: 'pointer',
    };
  }

  if (hasCorrectAnswers && correctAnswers.includes(i)) {
    return {
      border: '1px solid #4CAF50',
      background: '#4CAF50',
      cursor: 'default',
    };
  }

  if (isSelected && hasCorrectAnswers && !correctAnswers.includes(i)) {
    return {
      border: '1px solid #E53935',
      background: '#E53935',
      cursor: 'default',
    };
  }

  return {
    border: '1px solid #6A6A6A',
    background: 'transparent',
    cursor: 'default',
  };
};
